const endpoint = '/api/properties/integration';

export default ['api', 'currentPropertyService', function (api, currentPropertyService) {
    let integration = {};

    integration.logsEndpoint = (propertyId, type) => `/api/properties/${propertyId}/logs?source=${type}&type=Import`;
    integration.statusEndpoint = (propertyId, type) => `/api/${propertyId}/integration/status?type=${type}`;

    integration.testIntegration = propertyId => {
        return api.get(`${endpoint}/${propertyId}/test`).then(response => response.data);
    };

    integration.getVersion = propertyId => {
        return api.get(`${endpoint}/${propertyId}/version`).then(response => response.data);
    };

    integration.integrationImport = propertyId => {
        return api.get(`${endpoint}/${propertyId}/import`).then(response => response.data)
            .catch(() => {
                //Integration not established
            });
    };

    integration.integrationTreatmentCollect = propertyId => {
        if (!integration.treatments) {
            return api.get(`${endpoint}/${propertyId}/treatments`).then(response => {
                integration.treatments = response.data;
                return response.data;
            }).catch(() => {
                //Integration not established
            });
        }

        return Promise.resolve(integration.treatments);
    };

    integration.integrationPackageCollect = propertyId => {
        if (!integration.spadays) {
            return api.get(`${endpoint}/${propertyId}/spadays`).then(response => {
                integration.spadays = response.data;
                return response.data;
            }).catch(() => {
                //Integration not established
            });
        }

        return Promise.resolve(integration.spadays);
    };

    integration.integrationSinglePackageCollect = (propertyId, packageId) => {
        if (!integration[packageId]) {
            return api.get(`${endpoint}/${propertyId}/spadays/${packageId}`).then(response => {
                integration[packageId] = response.data;
                return response.data;
            }).catch(() => {
                //Integration not established
            });
        }

        return Promise.resolve(integration[packageId]);
    };


    integration.integrationActivityCollect = propertyId => {
        if (!integration.activities) {
            return api.get(`${endpoint}/${propertyId}/activities`).then(response => {
                integration.activities = response.data;
                return response.data;
            }).catch(() => {
                //Integration not established
            });
        }

        return Promise.resolve(integration.activities);
    };

    integration.integrationExtraCollect = propertyId => {
        if (!integration.extras) {
            return api.get(`${endpoint}/${propertyId}/extras`).then(response => {
                integration.extras = response.data;
                return response.data;
            }).catch(() => {
                //Integration not established
            });
        }

        return Promise.resolve(integration.extras);
    };

    integration.getImportLogs = (propertyId, type) => {
        return api.get(integration.logsEndpoint(propertyId, type)).then(response => {
            return response.data;
        });
    };

    integration.getIntegrationStatus = type => {
        return api.get(integration.statusEndpoint(currentPropertyService.get().id, type)).then(response => {
            return response.data;
        });
    };

    integration.setEmailPasswords = csv => {
        return api.upload(`${endpoint}/${api.property()}/importUsers`, csv).then(response => response.data);
    };

    integration.uploadContracts = csv => {
        return api.upload(`${endpoint}/uploadContracts`, csv).then(response => response.data);
    };

    return integration;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/integration.api.service.js